module.exports = __webpack_public_path__ + "images/premium4-cd61515762b02f96219ee8e80fcc3e17.jpg";